import React, { useEffect, useState } from "react";

const MessagesPage = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    // In production this would fetch from an API
    const fetchMessages = async () => {
      const res = await fetch("/api/getContactMessages");
      const data = await res.json();
      setMessages(data);
    };

    fetchMessages();
  }, []);

  return (
    <main className="flex-1 p-8 bg-neutral-950 min-h-screen">
      <h1 className="text-3xl font-bold text-white mb-2">📨 Messages</h1>
      <p className="text-gray-400 mb-6">Here are recent messages submitted through the contact form.</p>

      <div className="grid grid-cols-1 gap-6">
        {messages.length === 0 ? (
          <div className="text-gray-400 text-center">No messages found.</div>
        ) : (
          messages.map((msg) => (
            <div
              key={msg.id}
              className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 shadow hover:shadow-lg transition"
            >
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-lg font-semibold text-white">{msg.subject}</h2>
                <span className="text-xs text-gray-500">{msg.timestamp}</span>
              </div>
              <p className="text-gray-300 mb-2">{msg.message}</p>
              <div className="text-sm text-gray-400">
                <span className="font-medium text-white">{msg.name}</span> —{" "}
                <a href={`mailto:${msg.email}`} className="text-blue-400 hover:underline">
                  {msg.email}
                </a>
                <br />
                {msg.phone && (
                  <>
                    📞{" "}
                    <a href={`tel:${msg.phone}`} className="text-blue-400 hover:underline">
                      {msg.phone}
                    </a>
                  </>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </main>
  );
};

export default MessagesPage;
